import { render, staticRenderFns } from "./PaymentFeedback.vue?vue&type=template&id=37ee7c60&scoped=true&"
import script from "./PaymentFeedback.vue?vue&type=script&lang=js&"
export * from "./PaymentFeedback.vue?vue&type=script&lang=js&"
import style0 from "./PaymentFeedback.vue?vue&type=style&index=0&id=37ee7c60&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ee7c60",
  null
  
)

export default component.exports